/**
 * @name breakpoints
 * @constant
 * @function
 * @description Contains minimum and maximum width for device screen sizes
 */

export const breakpoints = {
    "mobile" : {
        "max": 640
    },
    "tablet": {
        "max": 991,
        "min": 641
    },
    "laptop" : {
        "min": 992,
        "max": 1824
    },
    "desktop" : {
        "min": 1825
    }
};

export default breakpoints;